import fanyi from "@/utlis/language.js";
import fun from "@/utlis/CommonlyUsedFunctions.js";

let ps = {
  step: 1,
  alreadyCompleted: false,
  formregister: { market_channel: [], country_phone: "+39" },
  inputRequireVer: {
    required: true,
    message: fanyi("此字段为必填项"),
    trigger: "blur",
  },

  Countdown: 60,
  DetailsOfTheCompany: null,
  RakumartExperience: null,
  CompleteSuccess: null,
  registerBodyCarouselRef: null,
  backLastPage() {
    if (ps.step == 1) {
      ps.DetailsOfTheCompany.goBack();
    } else if (ps.step == 2) {
      ps.RakumartExperience.goBack();
    } else if (ps.step == 3) {
      ps.CompleteSuccess.goBack();
    }
  },
  goNext() {
    if (ps.step < 2) {
      ps.step++;
    } else if (ps.step == 2) {
      ps.step = 3;
    }
  },
  setAlreadyCompleted(userInfo) {
    ps.alreadyCompleted = !!(
      userInfo && String(userInfo.user_id_card || "").trim()
    );
  },
  buildSupplementPayload(userId) {
    const f = ps.formregister;
    return {
      id: userId,
      user_id: userId,
      company_name: f.company_name,
      company_web: f.company_web || "",
      user_type: f.user_type,
      industry_type: f.industry_type,
      user_id_card: f.user_id_card,
      commodity_use: f.commodity_use,
      sales_type: f.sales_type,
      market_channel: JSON.stringify(
        Array.isArray(f.market_channel) ? f.market_channel : [],
      ),
      import_amount: f.import_amount,
      import_industry: f.import_industry,
      experience: f.experience,
    };
  },
};

export default ps;
